import { render } from "./PortalHomeComponent.vue?vue&type=template&id=5931c072&scoped=true"
import script from "./PortalHomeComponent.vue?vue&type=script&lang=js"
export * from "./PortalHomeComponent.vue?vue&type=script&lang=js"

import "./PortalHomeComponent.vue?vue&type=style&index=0&id=5931c072&scoped=true&lang=css"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5931c072"]])

export default __exports__